// Message Action Button Styles
// Provides consistent styling for all message action buttons

export const MESSAGE_ACTION_STYLES = {
  // Base button styles - consistent across all message actions
  BASE: 'p-1.5 rounded-full transition-colors duration-200',
  
  // Default state styles
  DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700',
  
  // Active/selected state styles
  ACTIVE: 'bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400',
  
  // Disabled state styles
  DISABLED: 'opacity-50 cursor-not-allowed',
  
  // Icon sizes
  ICON_SIZE: 16,
  
  // Specific action colors
  COLORS: {
    LIKE: {
      DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200',
      ACTIVE: 'text-blue-600 fill-blue-500 dark:text-blue-400 dark:fill-blue-300'
    },
    DISLIKE: {
      DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200',
      ACTIVE: 'text-red-600 fill-red-500 dark:text-red-400 dark:fill-red-300'
    },
    SPEAKER: {
      DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200',
      ACTIVE: 'text-green-600 dark:text-green-400'
    },
    EXPORT: {
      DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'
    },
    DEBUG: {
      DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200',
      ACTIVE: 'text-purple-600 dark:text-purple-400 bg-purple-100 dark:bg-purple-900/30'
    },
    QUOTE: {
      DEFAULT: 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200',
      ACTIVE: 'bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400'
    }
  }
};

/**
 * Generates consistent button className for message actions
 * @param {string} action - The action type (like, dislike, speaker, etc.)
 * @param {boolean} isActive - Whether the button is in active state
 * @param {boolean} isDisabled - Whether the button is disabled
 * @returns {string} Combined className string
 */
export const getMessageActionClassName = (action, isActive = false, isDisabled = false) => {
  const baseClass = MESSAGE_ACTION_STYLES.BASE;
  const colorClass = isActive 
    ? MESSAGE_ACTION_STYLES.COLORS[action.toUpperCase()]?.ACTIVE || MESSAGE_ACTION_STYLES.ACTIVE
    : MESSAGE_ACTION_STYLES.COLORS[action.toUpperCase()]?.DEFAULT || MESSAGE_ACTION_STYLES.DEFAULT;
  const disabledClass = isDisabled ? MESSAGE_ACTION_STYLES.DISABLED : '';
  
  return `${baseClass} ${colorClass} ${disabledClass}`.trim();
};

export default {
  MESSAGE_ACTION_STYLES,
  getMessageActionClassName
};
